"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGridOptions = void 0;
var tslib_1 = require("tslib");
var cellClass_1 = require("./cell/cellClass");
var ColumnHeader_1 = tslib_1.__importDefault(require("./structure/headers/ColumnHeader"));
var columnSizing_1 = require("./resizing/columnSizing");
var colDefHeaderClass_1 = require("./structure/colDefHeaderClass");
var ColumnGroupHeader_1 = tslib_1.__importDefault(require("./structure/headers/ColumnGroupHeader"));
var onCellClick_1 = require("./cell/onCellClick");
var constants_1 = require("./base/constants");
var colDefTemplates_1 = require("./structure/colDefTemplates");
var loadingRenderer_1 = require("./data/loadingRenderer");
var all_modules_1 = require("@ag-grid-community/all-modules");
function createGridOptions(table, tableMethods, props) {
    var _a;
    var colDefs = table.tableDescriptor.colDefs;
    var pageSize = props.pageSize;
    var totalRowCount = table.getRowCount();
    var allColumnDefs = colDefs.sliceColDefs.concat(colDefs.rootDataColDefs);
    /*
     * This is a half-workaround around the visual weirdness where upon load/sort ag-grid renders full
     * page of empty rows and then possibly shrinks back to the actual size of data obtained from backend.
     *
     * since the code knows total count of all data on all pages already, it is possible to set the effective
     * page size to minimum of the requested page size and the total of all data => thus eliminating this
     * effect.
     *
     * the only dumb thing about this approach is that dynamically added subtotals (via menu) kick this
     * slightly out of balance as extra rows get added and ag-grid needs to load additional pages... and so an
     * extra buffer of couple of rows in case it is possible add subtotals. while there will be some expanding
     * and shrinking, it will not be so big.
     */
    var extraTotalsBuffer = props.config && props.config.menu ? 10 : 0;
    var effectivePageSize = Math.min(pageSize, totalRowCount + extraTotalsBuffer);
    var commonHeaderComponentParams = {
        onMenuAggregationClick: tableMethods.onMenuAggregationClick,
        getTableDescriptor: function () { return table.tableDescriptor; },
        getExecutionDefinition: tableMethods.getExecutionDefinition,
        getColumnTotals: tableMethods.getColumnTotals,
        intl: props.intl,
    };
    return {
        // Initial data
        columnDefs: allColumnDefs,
        rowData: [],
        defaultColDef: {
            cellClass: cellClass_1.cellClassFactory(table, props),
            headerComponentFramework: ColumnHeader_1.default,
            headerComponentParams: tslib_1.__assign({ menu: tableMethods.getMenuConfig, enableSorting: true }, commonHeaderComponentParams),
            minWidth: columnSizing_1.MIN_WIDTH,
            sortable: true,
            resizable: true,
        },
        defaultColGroupDef: {
            headerClass: colDefHeaderClass_1.headerClassFactory(table, props),
            children: [],
            headerGroupComponentFramework: ColumnGroupHeader_1.default,
            headerGroupComponentParams: tslib_1.__assign({ menu: tableMethods.getMenuConfig }, commonHeaderComponentParams),
        },
        onCellClicked: onCellClick_1.onCellClickedFactory(table, props),
        onSortChanged: tableMethods.onSortChanged,
        onColumnResized: tableMethods.onGridColumnResized,
        onGridColumnsChanged: tableMethods.onGridColumnsChanged,
        onModelUpdated: tableMethods.onModelUpdated,
        onPinnedRowDataChanged: tableMethods.onPinnedRowDataChanged,
        // Basic options
        suppressMovableColumns: true,
        suppressCellSelection: true,
        suppressAutoSize: tableMethods.hasColumnWidths,
        // infinite scrolling model
        rowModelType: "infinite",
        serverSideStoreType: all_modules_1.ServerSideStoreType.Partial,
        paginationPageSize: effectivePageSize,
        cacheOverflowSize: effectivePageSize,
        cacheBlockSize: effectivePageSize,
        maxConcurrentDatasourceRequests: 1,
        infiniteInitialRowCount: effectivePageSize,
        maxBlocksInCache: 10,
        onGridReady: tableMethods.onGridReady,
        onFirstDataRendered: tableMethods.onFirstDataRendered,
        onBodyScroll: tableMethods.onBodyScroll,
        onGridSizeChanged: tableMethods.onGridSizeChanged,
        // Column types
        columnTypes: (_a = {},
            _a[constants_1.ROW_ATTRIBUTE_COLUMN] = colDefTemplates_1.rowAttributeTemplate(table, props),
            _a[constants_1.COLUMN_ATTRIBUTE_COLUMN] = colDefTemplates_1.columnAttributeTemplate(table, props),
            _a[constants_1.MEASURE_COLUMN] = colDefTemplates_1.measureColumnTemplate(table, props),
            _a),
        // Custom renderers
        frameworkComponents: {
            // any is needed here because of incompatible types with AgGridReact types
            loadingRenderer: loadingRenderer_1.createLoadingRenderer(table, props),
        },
        // Custom CSS classes
        rowClass: "gd-table-row",
        rowHeight: constants_1.DEFAULT_ROW_HEIGHT,
        autoSizePadding: constants_1.DEFAULT_AUTOSIZE_PADDING,
        enableBrowserTooltips: true,
    };
}
exports.createGridOptions = createGridOptions;
//# sourceMappingURL=gridOptions.js.map